// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper-upload-form[data-v-1d609dbc] {\n  display: flex;\n  margin: 2em auto;\n  align-items: center;\n  justify-content: space-between;\n}\n.wrapper-upload-form .label-blue[data-v-1d609dbc] {\n  color: #2b69bb;\n  font-weight: 500;\n}", ""]);
// Exports
module.exports = exports;
